export interface NoteModel {
  id: number;
  description: string;
  remarks: string;
  pinned: boolean;
  objectId: string;
  objectType: string;
}

export class NoteModel {
  static default(): NoteModel {
    return {
      id: null,
      description: null,
      remarks: null,
      pinned: false,
      objectId: null,
      objectType: null,
    };
  }
}
